module.exports = __webpack_public_path__ + "img/official-logo@2x.c01cad76.png";